<template>
  <div>
    <v-app-bar fixed app short class="shadow">
      <!-- color="wall" -->
      <v-app-bar-nav-icon color="text" @click.stop="toggleDrawer" />
      <router-link to="/">
        <v-img
          max-height="40px"
          max-width="40px"
          align="center"
          justify="center"
          class="my-2"
          src="@/assets/img/logo.png"
        ></v-img>
      </router-link>
      <v-spacer />
      <h4>{{ $dayjs().format("MMM-DD-YYYY") }}</h4>
      <!-- <v-btn icon color="text" class="mx-1">
        <v-icon> mdi-apps </v-icon>
      </v-btn>
      <v-btn icon color="text">
        <v-icon> mdi-clipboard-arrow-down </v-icon>
      </v-btn> -->
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      app
      class="wall"
      :mini-variant="mini"
      mini-variant-width="80"
      :expand-on-hover="mini"
    >
      <v-card dark tile flat class="wall">
        <template v-if="!mini">
          <div class="d-flex justify-end pa-4 pb-0">
            <user-avatar-menu />
          </div>
          <div class="d-flex flex-column align-center text-center mb-2">
            <v-img
              max-height="96px"
              max-width="96px"
              class="my-6"
              src="@/assets/img/logo.png"
            />
            <h4 style="font-size: 14px">NP project</h4>
            <div class="caption secondary--text">email@email.com</div>
          </div>
        </template>
        <v-list nav class="menu-links">
          <div v-for="(item, i) in links" :key="i" cl>
            <p
              class="upperline mt-8 mb-2 primary--text mx-4"
              v-if="i === 1 && !mini"
            >
              DIY (Do It Yourself) Projects
            </p>
            <p class="upperline mt-8 mb-2 primary--text mx-4" v-if="i === 6 && !mini">
              DEEP Projects
            </p>
            <div v-if="item.items">
              <v-list-group no-action class="mb-1">
                <template #activator>
                  <v-list-item-icon>
                    <v-icon v-text="item.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item link :to="item.path" class="item-link" />
                  <v-list-item-content>
                    <v-list-item-title v-text="item.title"></v-list-item-title>
                  </v-list-item-content>
                </template>

                <!-- sub links -->
                <template v-for="(child, i) in item.items">
                  <v-list-item
                    v-if="child"
                    :to="child.path"
                    exact
                    :key="i"
                    router
                  >
                    <v-list-item-icon class="mr-1 ml-n2 mt-5">
                      <v-icon size="7">mdi-brightness-1</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title
                        v-text="child.title"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-list-group>
            </div>
            <!---->
            
            <div v-else>
              <p
                class="upperline mt-8 mb-2 primary--text mx-4"
                v-if="i === 0 && !mini"
              >
                dashbaords
              </p>
              <v-list-item
                color="primary"
                class="alone-list mb-1"
                :to="item.path"
                link
              >
                <v-list-item-icon class="regular">
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text="item.title"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </div>
          </div>
        </v-list>
        
      </v-card>
    </v-navigation-drawer>

    <v-main class="accent">
      <router-view />
    </v-main>
  </div>
</template>
<script>
import UserAvatarMenu from "@/components/UserAvatarMenu.vue";
export default {
  components: { UserAvatarMenu },
  data() {
    return {
      mini: false,
      drawer: true,
      links: [
        {
          title: "Dashboard",
          icon: "mdi-view-carousel",
          path: { path: "/" },
        },
        // {
        //   title: "Analytics",
        //   icon: "mdi-google-analytics",
        //   path: { path: "/#" },
        // },
        // {
        //   title: "All Projects",
        //   icon: "mdi-cube",
        //   path: { path: "/##" },
        // },
        {
          title: "Organization Info",
          icon: "mdi-domain",
          path: { path: "/organization-info", query: { s: "1" } },
          items: [
            {
              title: "Basic Info",
              path: { path: "/organization-info", query: { s: "1" } },
            },
            {
              title: "NP Info",
              path: { path: "/organization-info", query: { s: "2" } },
            },
            {
              title: "NPO Info",
              path: { path: "/organization-info", query: { s: "3" } },
            },
            {
              title: "Documents Info",
              path: { path: "/organization-info", query: { s: "4" } },
            },
            {
              title: "History Info",
              path: { path: "/organization-info", query: { s: "5" } },
            },
            {
              title: "Details Info",
              path: { path: "/organization-info", query: { s: "6" } },
            },
          ],
        },
        {
          title: "Engagement Info",
          icon: "mdi-clipboard-check",
          path: { path: "/engagement-info", query: { s: "1" } },
          items: [
            {
              title: "More NPO details",
              path: { path: "/engagement-info", query: { s: "1" } },
            },
            {
              title: "Beneficiary details",
              path: { path: "/engagement-info", query: { s: "2" } },
            },
          ],
        },
        {
          title: "Nominated Personal",
          icon: "mdi-account-tie",
          path: { path: "/nominated-personal", query: { s: "1" } },
          items: [
            {
              title: "NP details",
              path: { path: "/nominated-personal", query: { s: "1" } },
            },
          ],
        },
        {
          title: "Beneficiary",
          icon: "mdi-handshake",
          path: { path: "/beneficiary", query: { s: "1" } },
          items: [
            {
              title: "Basic Info",
              path: { path: "/beneficiary", query: { s: "1" } },
            }
          ],
        },
        {
          title: "Digital Signature",
          icon: "mdi-file-sign",
          path: { path: "/sign", query: { s: "1" } },
          items: [
            {
              title: "Signature Form",
              path: { path: "/sign", query: { s: "1" } },
            }
          ],
        },
        //
        {
          title: "Organization Info",
          icon: "mdi-domain",
          path: { path: "/organization-infod", query: { s: "1" } },
          items: [
            {
              title: "Basic Info",
              path: { path: "/organization-infod", query: { s: "1" } },
            },
            {
              title: "NP Info",
              path: { path: "/organization-infod", query: { s: "2" } },
            },
            {
              title: "NPO Info",
              path: { path: "/organization-infod", query: { s: "3" } },
            },
            {
              title: "Documents Info",
              path: { path: "/organization-infod", query: { s: "4" } },
            },
            {
              title: "History Info",
              path: { path: "/organization-infod", query: { s: "5" } },
            },
            {
              title: "Details Info",
              path: { path: "/organization-infod", query: { s: "6" } },
            },
          ],
        },
        {
          title: "Beneficiary",
          icon: "mdi-handshake",
          path: { path: "/beneficiaryd", query: { s: "1" } },
          items: [
            {
              title: "Basic Info",
              path: { path: "/beneficiaryd", query: { s: "1" } },
            }
          ],
        },
        {
          title: "Digital Signature",
          icon: "mdi-file-sign",
          path: { path: "/signd", query: { s: "1" } },
          items: [
            {
              title: "Signature Form",
              path: { path: "/signd", query: { s: "1" } },
            }
          ],
        },
      ],
    };
  },
  methods: {
    toggleDrawer() {
      if (this.$vuetify.breakpoint.mdAndDown) {
        this.mini = false;
        this.drawer = !this.drawer;
      } else {
        this.drawer = true;
        this.mini = !this.mini;
      }
    },
  },
};
</script>
<style lang="scss">
.item-link {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}
</style>
